import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Container, CssBaseline, Typography } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))

const SentOk = () => {
  const classes = useStyles()

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <Typography component="h1" variant="h5">
          予約申込の完了
        </Typography>
        <br />
        <p>
          確認メールをお送りしました
          <br />
          ご予約内容を必ずご確認ください。
        </p>
      </div>
    </Container>
  )
}

export default SentOk
